import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  fetchStressReportDetailDimensionsAandB(_, params) {
    return axios.get(`${serverUrl}/reports/stress_report_detail_AandB/custom_total_symptome/?${params}`)
  },
  fetchStressReportDetailGeneralAandB(_, params) {
    return axios.get(`${serverUrl}/reports/stress_report_detail_AandB/custom_total_general/?${params}`)
  },
}